// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"458":"da27cb5a","488":"c8ae6561"}[chunkId] + ".chunk.js";
};